var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.hasRisk ? 'warning-triangle' : 'check-circle',{tag:"component",class:_vm.classes,attrs:{"data-tooltip":_vm.risk ? `Risk: ${_vm.risk.level}` : 'Risk Unknown'}})
}
var staticRenderFns = []

export { render, staticRenderFns }